import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useRecentlyViewedStore } from '../store';
import { formatPrice } from '../utils/helpers';
import { Clock } from '@phosphor-icons/react';

const RecentlyViewed = () => {
  const { items } = useRecentlyViewedStore();

  if (items.length === 0) return null;

  return (
    <section className="py-12 bg-background-subtle">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <Clock size={24} className="text-primary" />
          <h2 className="font-display text-2xl text-secondary">Recently Viewed</h2>
        </div>
        
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
          {items.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className="flex-shrink-0 w-48"
            >
              <Link to={`/product/${product.id}`} className="block group">
                <div className="aspect-square overflow-hidden bg-white mb-2">
                  <img
                    src={product.image_urls?.[0] || 'https://images.unsplash.com/photo-1736436789706-005f2218a96d?w=200'}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <h3 className="font-body text-sm text-secondary group-hover:text-primary transition-colors line-clamp-1">
                  {product.name}
                </h3>
                <p className="font-body text-sm text-primary font-medium">
                  {formatPrice(product.selling_rate)}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
